// 智能入职
export const socialMngRouter = [
  // 政策速递审核模块
  {
    path: '/socialMng/policyReview',
    name: 'PolicyReview',
    component: () => import('../views/SocialMng/PolicyReview')
  },
  // 订单管理模块
  {
    path: '/socialMng/orderList',
    name: 'OrderList',
    component: () => import('../views/SocialMng/OrderList')
  },
  // 订单管理--订单详情
  {
    path: '/socialMng/orderDetail',
    name: 'orderDetail',
    component: () => import('../views/SocialMng/orderDetail')
  },
]